import * as yup from "yup";

export const EditEvidenceFormValidationSchema: yup.AnyObjectSchema = yup.object(
    {
        validFromDate: yup
            .date()
            .required("Please enter a valid date")
            .typeError("Please enter a valid date"),
        validToDate: yup
            .date()
            .min(
                yup.ref("validFromDate"),
                "Must be equal/after valid from date"
            )
            .required("Please enter a valid date")
            .typeError("Please enter a valid date"),
    }
);

export type EditEvidenceFormValues = {
    validFromDate: Date | null;
    validToDate: Date | null;
};

export const defaultEditEvidenceFormValues: EditEvidenceFormValues = {
    validFromDate: null,
    validToDate: null,
};
